// models/pedidos/StatusConexaoWhats.js
const StatusConexaoWhats = Object.freeze({
    Aberta: 'open',
    Conectando: 'connecting',
    Fechada: 'close',
});

const descricoesStatusConexaoWhats = Object.freeze({
    [StatusConexaoWhats.Aberta]: {
        descricao: 'Conectado',
        cor: '#198754',
    },
    [StatusConexaoWhats.Conectando]: {
        descricao: 'Conectando...',
        cor: '#fd7e14',
    },
    [StatusConexaoWhats.Fechada]: {
        descricao: 'Desconectado',
        cor: '#6c757d',
    },
    closed: {
        descricao: 'Desconectado',
        cor: '#6c757d',
    },
});

export const getDescricaoStatusConexaoWhats = (estado, conectado = false) => {
    if (conectado) {
        return descricoesStatusConexaoWhats[StatusConexaoWhats.Aberta];
    }

    const estadoNormalizado = String(estado || '').toLowerCase();

    return descricoesStatusConexaoWhats[estadoNormalizado] || {
        descricao: estado ? `Status: ${estado}` : 'Status não disponível',
        cor: '#6c757d',
    };
};

export default StatusConexaoWhats;
